import React, { useCallback, useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useSubheader } from "../../../../_metronic/layout"
import { loadUserLogin } from "../../../service/userManagementAction"
import { useUrlParam } from "../../../hooks/useUrlParams"
import { useLocation } from "react-router"
import { useHistory } from "react-router-dom"
import { getUrlParsingPageFilter } from "../../../../config/EndpointCollection.js"
import { formatterRowComponent } from "../../../../component/atoms/Tabel"
import { sortCaret } from "../../../../_metronic/_helpers"
import { GetListRegionalHead } from "../../../../redux/actions/FieldOfficerAction"
import { timeStampToDate } from "../../../helpers/DateHelper"
import { Badge, Card, OverlayTrigger, Tooltip } from "react-bootstrap"
import { DetailSvgIcon, EditSvgIcon } from "../../../../component/atoms/Icons/SVG"
import { EmptyCard, Search, TableSkeleton, TableView } from "../../../../component"
import { CardBody } from "../../../../_metronic/_partials/controls"
import { RoutesConstants } from "../../../../constants/RoutesConstants"
import {
  DATE_TYPE_ENUM,
  FIELD_OFFICER_ROLE_ENUM,
  ROUTING_STATUS
} from "../../../../constants/StringConstant"
import { useTranslation } from "react-i18next"
import { PRIVILEGE_ENUM } from "../../../../constants/PrivilegeConstants.js"
import { stringFormatting } from "../../../helpers/TextHelper.js"
import { ILLUSTRATION_CONSTANTS } from "../../../../constants/ImageConstants.js"

export const ListRegionalHead = () => {
  const { t } = useTranslation()
  const [dataList, setDataList] = useState([])
  const [isActiveSearch, setIsActiveSearch] = useState(false)
  const [search, setSearch] = useState({ keyword: "" })
  const [queryStringObj] = useState(undefined)
  const { FieldOfficer, General } = useSelector((state) => state)
  const subheader = useSubheader()
  const privileges = loadUserLogin().privilege
  const formRef = useRef()
  const urlParam = useUrlParam()
  const location = useLocation()
  const history = useHistory()
  const dispatch = useDispatch()

  useEffect(() => {
    subheader.setTitle(t("sub_header_regional_head"))
    subheader.setButton(null)
  }, [])

  useEffect(() => {
    if (FieldOfficer?.pageData) {
      setDataList(FieldOfficer.pageData)
    }
  }, [General, FieldOfficer])

  useEffect(() => {
    if (queryStringObj?.keyword) {
      setSearch({ keyword: queryStringObj?.keyword })
      setIsActiveSearch(true)
    }
  }, [queryStringObj])

  useEffect(() => {
    const result = location?.search
    fetchData(result)
  }, [location.search])

  const changePage = useCallback(
    (param) => {
      let urlParam
      if (param.sortField != null) {
        urlParam = getUrlParsingPageFilter({
          ...param,
          sort: param.sortField + "," + param.sortOrder,
          keyword: search.keyword
        })
      } else {
        urlParam = getUrlParsingPageFilter({
          ...param,
          keyword: search.keyword
        })
      }
      history.push({ pathname: location.pathname, search: urlParam })
    },
    [search]
  )

  function onSearch(value) {
    setSearch({ keyword: value.keyword })
    setIsActiveSearch(true)
    let param = {
      keyword: value.keyword
    }
    const url = urlParam.stringifyObj(param)
    history.push({ pathname: location.pathname, search: url })
  }

  function fetchData(param) {
    return dispatch(GetListRegionalHead(param))
  }

  function resetSearch() {
    urlParam.resetKeyword()
    setSearch({ keyword: "" })
  }

  const uiCode = (e) => {
    return <div className={"font-weight-bolder"}>{stringFormatting(e?.code)}</div>
  }

  const uiRegionalName = (e) => {
    return <div className={"font-weight-bolder"}>{stringFormatting(e?.regional_name)}</div>
  }

  const uiName = (e) => {
    return (
      <div>
        <div className={"font-weight-bolder"}>{stringFormatting(e?.name)}</div>
        <div>{stringFormatting(e?.phone_number)}</div>
      </div>
    )
  }

  const UiDate = (e) => {
    return (
      <div>
        <div>
          {stringFormatting(timeStampToDate(e.created_date, DATE_TYPE_ENUM.ISO_DATE_STRAP))}
        </div>
        <div>{stringFormatting(timeStampToDate(e.created_date, DATE_TYPE_ENUM.ISO_TIME_ID))}</div>
      </div>
    )
  }

  const uiStatus = (e) => {
    return (
      <Badge
        variant={e?.status_enum === ROUTING_STATUS.STATUS_ENUM.ACTIVE ? "primary" : "secondary"}>
        {stringFormatting(e.status_string)}
      </Badge>
    )
  }

  const UiActions = (e) => {
    return (
      <div>
        {/* //TODO set regional head role privilage enum */}
        {privileges.indexOf(PRIVILEGE_ENUM.DETAIL_FIELD_OFFICER_COORDINATOR) > 1 && (
          <OverlayTrigger overlay={<Tooltip id="products-edit-tooltip">Detail</Tooltip>}>
            <div
              className="btn btn-icon btn-detail btn-hover-secondary btn-sm mx-3"
              onClick={() =>
                history.push(
                  //TODO create route constant for regional head page
                  RoutesConstants.FIELD_OFFICER.DETAIL_FO(
                    FIELD_OFFICER_ROLE_ENUM.REGIONAL_HEAD,
                    e?.id
                  )
                )
              }>
              <DetailSvgIcon />
            </div>
          </OverlayTrigger>
        )}
        {/* //TODO set regional head role privilage enum */}
        {privileges.indexOf(PRIVILEGE_ENUM.EDIT_FIELD_OFFICER) > -1 && (
          <OverlayTrigger overlay={<Tooltip id="products-edit-tooltip">Edit</Tooltip>}>
            <div
              className="btn btn-icon btn-detail btn-hover-secondary btn-sm mx-3"
              //TODO create route constant for regional head page
              onClick={() => history.push(RoutesConstants.FIELD_OFFICER.EDIT_FO(e.id))}>
              <EditSvgIcon />
            </div>
          </OverlayTrigger>
        )}
      </div>
    )
  }

  const columnProperties = [
    {
      dataField: "code",
      text: t("table_header_id_regional_head"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiCode
      },
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "name",
      text: t("table_header_name").toUpperCase(),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiName
      },
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "regional_head",
      text: t("table_header_regional").toUpperCase(),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiRegionalName
      }
    },
    {
      dataField: "status",
      text: t("table_header_status").toUpperCase(),
      sort: false,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiStatus
      }
    },
    {
      dataField: "createdDate",
      text: t("table_header_created_date").toUpperCase(),
      sort: true,
      sortCaret: sortCaret,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: UiDate
      },
      headerStyle: () => {
        return { width: "15%" }
      }
    },
    {
      dataField: "action",
      text: t("table_header_action").toUpperCase(),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: UiActions
      },
      headerStyle: () => {
        return { width: "12%" }
      }
    }
  ]

  return (
    <>
      <div className="filter-container">
        <div className="d-flex flex-wrap justify-content-between align-items-center mb-10">
          <Search
            isActiveSearch={isActiveSearch}
            placeholder={t("placeholder_insert_regional_head_name")}
            onSubmitForm={onSearch}
            initialValues={search}
            name={"keyword"}
            innerRef={formRef}
            trigerReset={resetSearch}
          />
        </div>
      </div>
      <Card>
        <CardBody>
          {General.loading ? (
            <TableSkeleton column={6} row={10} />
          ) : dataList?.length == 0 ? (
            <EmptyCard
              image={
                isActiveSearch
                  ? ILLUSTRATION_CONSTANTS.NOT_FOUND_DATA
                  : ILLUSTRATION_CONSTANTS.EMPTY_STATE_NO_DATA
              }
              body={
                isActiveSearch
                  ? t("messages_response_searching_not_found")
                  : t("messages_response_empty_state", { name: t("label_regional_head") })
              }
              subtitle={isActiveSearch ? t("messages_response_search_not_found_subtitle") : null}
            />
          ) : (
            ""
          )}
          <TableView
            dataTable={dataList ?? []}
            loadingGetData={General?.loading}
            callbackAfterPageChange={changePage}
            columnProperties={columnProperties}
            currentPage={FieldOfficer?.page?.currentPage ?? 0}
            currentElement={FieldOfficer?.page?.currentElement ?? 10}
            totalCount={FieldOfficer?.page?.totalCount ?? 0}
            rowClasses={() => {
              return "cursor-pointer"
            }}
          />
        </CardBody>
      </Card>
    </>
  )
}